module.exports = __webpack_public_path__ + "80a24c5dc7906cfb3f7a0c2158c152ea.jpg";